import { ErrorInRoute } from "@core/presentation/components/routing/error-in-route/error-in-route.component.tsx";
import { Route } from "react-router";

const REPORT_SEARCH = "search";

export const ReportRoutes = {
    Report: "/report",
    ReportHistorical: "/report/historical",
    Search: REPORT_SEARCH,
    SEARCH_MOBILE: REPORT_SEARCH,
} as const;

export const reportRoutes = (
    <Route
        path={ReportRoutes.Report}
        errorElement={<ErrorInRoute />}
        lazy={async () => {
            const { ReportModuleLayout } =
                await import("@report/presentation/layout/report-module.layout.tsx");
            return { Component: ReportModuleLayout };
        }}
    >
        <Route
            index
            lazy={async () => {
                const { ReportPage } =
                    await import("@report/presentation/pages/report/report.page.tsx");
                return { Component: ReportPage };
            }}
        />

        <Route
            path={ReportRoutes.ReportHistorical}
            lazy={async () => {
                const { HistoricalPage } =
                    await import("@report/presentation/pages/historical/historical.page.tsx");
                return { Component: HistoricalPage };
            }}
        />
    </Route>
);
